import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAddMisconnectedCustomersDialogPageStyles = makeStyles({
    root: {
        ...shorthands.padding('1rem', tokens.spacingHorizontalXXXL),
        alignSelf: 'flex-start',
        justifyItems: 'start',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
    },
    actions: {
        marginTop: '10px',
        alignSelf: 'end',
    },
    formField: {
        display: 'flex',
        flexDirection: 'column',
        '& > label': {
            marginBottom: tokens.spacingVerticalMNudge,
        },
    },
    warning: {
        color: tokens.colorNeutralForeground3,
    },
    danger: {
        color: tokens.colorStatusDangerForeground3,
    },
});
